// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.firstBotPromptContainer {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 36px;
  padding: 20px;
  width: 100%;
  /* One shared width for the whole block: the hero AND the highlights grid both
     span this, so the grid's right edge lines up exactly with the hero (the "red
     line"). Caps the sprawl on very wide screens; 100% keeps it responsive. */
  max-width: 1500px;
}

/* Hero spans the shared container width so the highlights grid below lines up
   with its right edge. */
.fbp-hero {
  position: relative;
  border-radius: 28px;
  overflow: hidden;
  min-height: 320px;
  width: 100%;
  max-width: 100%;
  /* Brand-focused monochrome gradient */
  background: linear-gradient(135deg, #4510b0 65%, #5616ea 100%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  isolation: isolate;
}

/* Integration logos pinned across the top of the hero. */
.fbp-hero-logos {
  position: relative;
  z-index: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 24px clamp(24px,6vw,52px) 0;
}

.fbp-hero-logos .info-tooltip-wrapper {
  margin-left: 0;
}

.fbp-hero-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 30% 40%,rgba(255,255,255,0.35),rgba(255,255,255,0) 60%),
              radial-gradient(circle at 70% 65%,rgba(255,255,255,0.25),rgba(255,255,255,0) 55%);
  mix-blend-mode: overlay;
  pointer-events: none;
}

.fbp-hero-inner {
  position: relative;
  z-index: 1;
  padding: 38px clamp(24px,6vw,52px);
  max-width: 760px;
  display: flex;
  flex-direction: column;
  gap: 22px;
  color: #fff;
}

.fbp-hero-title {
  font-size: clamp(2.2rem,4.5vw,3.2rem);
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0;
}

.fbp-hero-sub {
  font-size: clamp(1rem,1.45vw,1.25rem);
  line-height: 1.5;
  margin: 0 0 8px 0;
  font-weight: 400;
  max-width: 640px;
}

/* Primary button reused */
.firstBotPromptAddBtn {
  border: none;
  outline: none;
  background-color: #ffffff;
  font-size: 21px;
  font-weight: 600;
  text-align: center;
  padding: 14px 32px;
  border-radius: 16px;
  color: #5616ea;
  display: inline-flex;
  gap: 12px;
  align-items: center;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(94,27,255,0.25);
  cursor: pointer;
  align-self: flex-start;
  transition: background .25s, color .25s, transform .25s, box-shadow .25s;
}

.firstBotPromptAddBtn:hover {
  background-color: #ebebeb;
  transform: translateY(-2px);
}

.firstBotPromptAddBtn:active {
  transform: translateY(0);
  box-shadow: 0 4px 14px rgba(94,27,255,0.25);
}

/* Sections */
.fbp-sections { display: flex; flex-direction: column; gap: 56px; }

.fbp-section-title {
  font-size: 1.6rem;
  margin: 0 0 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
}

.fbp-inline-icon { color: #5616ea; }

/* Features grid — a fixed 3 columns so the six highlights form a tidy 2x3 grid
   the same width as the hero (each box wider). Steps down on smaller screens. */
.fbp-feature-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px;
}

.fbp-feature {
  background: linear-gradient(145deg,#ffffff,#f4f4f8);
  border: 1px solid #e7e7ee;
  border-radius: 18px;
  padding: 18px 18px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 3px 10px rgba(0,0,0,0.06);
  transition: box-shadow .25s, transform .25s;
}

.fbp-feature:hover { box-shadow: 0 8px 22px rgba(0,0,0,0.08); transform: translateY(-3px); }

.fbp-feature-icon {
  width: 46px; height: 46px;
  flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: #5616ea15;
  color: #5616ea;
  border-radius: 50%;
  font-size: 22px;
}

.fbp-feature-body h4 { margin: 0 0 6px; font-size: 1.05rem; font-weight: 600; }
.fbp-feature-body p { margin: 0; font-size: .9rem; line-height: 1.4; color: #444; }

/* Integration logo chips (in the hero top strip) */
.fbp-logo {
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.14);
  cursor: pointer;
  transition: transform .2s, box-shadow .2s;
}

.fbp-logo:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.22);
}

.fbp-logo img {
  max-height: 26px;
  max-width: 100px;
  object-fit: contain;
}

/* "Any API" chip — signals the agent can integrate with any service. */
.fbp-logo-api {
  gap: 7px;
  font-weight: 700;
  font-size: 14px;
  color: #5616ea;
  white-space: nowrap;
}

.fbp-logo-api svg { font-size: 15px; }

/* "+ more" chip after the last logo — signals there are more integrations. */
.fbp-logo-more {
  font-weight: 700;
  font-size: 14px;
  color: #5616ea;
  white-space: nowrap;
}

/* Removed steps & tips sections per request */

/* Responsive adjustments */
@media (max-width: 860px) {
  .fbp-hero-inner { padding: 40px 36px; }
  .fbp-hero-logos { padding: 22px 36px 0; }
  .fbp-hero { min-height: 280px; }
  .fbp-feature-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 600px) {
  .firstBotPromptContainer { gap: 32px; }
  .fbp-feature-grid { grid-template-columns: 1fr; }
  .fbp-hero-inner { padding: 34px 28px; }
  .fbp-hero-logos { padding: 20px 28px 0; gap: 8px; }
  .fbp-hero-title { font-size: 2.2rem; }
  .fbp-feature-body p { font-size: .8rem; }
  .fbp-step { padding: 16px 18px; }
  .fbp-step-content p { font-size: .75rem; }
  .fbp-logo { height: 40px; padding: 6px 10px; }
  .fbp-logo img { max-height: 22px; max-width: 84px; }
}

@media (prefers-reduced-motion: reduce) {
  .firstBotPromptAddBtn,
  .fbp-feature,
  .fbp-logo,
  .fbp-step { transition: none; }
  .fbp-feature:hover,
  .fbp-logo:hover,
  .fbp-step:hover { transform: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/FirstBotPrompt.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,WAAW;EACX;;8EAE4E;EAC5E,iBAAiB;AACnB;;AAEA;yBACyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,8DAA8D;EAC9D,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,eAAe;EACf,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;+FAC6F;EAC7F,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA,aAAa;AACb,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAElE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB,cAAc,EAAE;;AAEnC;gFACgF;AAChF;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA,qBAAqB,uCAAuC,EAAE,2BAA2B,EAAE;;AAE3F;EACE,WAAW,EAAE,YAAY;EACzB,cAAc;EACd,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uBAAuB,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC9E,sBAAsB,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAElF,mDAAmD;AACnD;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB,eAAe,EAAE;;AAErC,6EAA6E;AAC7E;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,8CAA8C;;AAE9C,2BAA2B;AAC3B;EACE,kBAAkB,kBAAkB,EAAE;EACtC,kBAAkB,oBAAoB,EAAE;EACxC,YAAY,iBAAiB,EAAE;EAC/B,oBAAoB,gDAAgD,EAAE;AACxE;;AAEA;EACE,2BAA2B,SAAS,EAAE;EACtC,oBAAoB,0BAA0B,EAAE;EAChD,kBAAkB,kBAAkB,EAAE;EACtC,kBAAkB,oBAAoB,EAAE,QAAQ,EAAE;EAClD,kBAAkB,iBAAiB,EAAE;EACrC,sBAAsB,gBAAgB,EAAE;EACxC,YAAY,kBAAkB,EAAE;EAChC,sBAAsB,iBAAiB,EAAE;EACzC,YAAY,YAAY,EAAE,iBAAiB,EAAE;EAC7C,gBAAgB,gBAAgB,EAAE,eAAe,EAAE;AACrD;;AAEA;EACE;;;cAGY,gBAAgB,EAAE;EAC9B;;oBAEkB,eAAe,EAAE;AACrC","sourcesContent":["/* Container */\r\n.firstBotPromptContainer {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 36px;\r\n  padding: 20px;\r\n  width: 100%;\r\n  /* One shared width for the whole block: the hero AND the highlights grid both\r\n     span this, so the grid's right edge lines up exactly with the hero (the \"red\r\n     line\"). Caps the sprawl on very wide screens; 100% keeps it responsive. */\r\n  max-width: 1500px;\r\n}\r\n\r\n/* Hero spans the shared container width so the highlights grid below lines up\r\n   with its right edge. */\r\n.fbp-hero {\r\n  position: relative;\r\n  border-radius: 28px;\r\n  overflow: hidden;\r\n  min-height: 320px;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  /* Brand-focused monochrome gradient */\r\n  background: linear-gradient(135deg, #4510b0 65%, #5616ea 100%);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  isolation: isolate;\r\n}\r\n\r\n/* Integration logos pinned across the top of the hero. */\r\n.fbp-hero-logos {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  padding: 24px clamp(24px,6vw,52px) 0;\r\n}\r\n\r\n.fbp-hero-logos .info-tooltip-wrapper {\r\n  margin-left: 0;\r\n}\r\n\r\n.fbp-hero-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: radial-gradient(circle at 30% 40%,rgba(255,255,255,0.35),rgba(255,255,255,0) 60%),\r\n              radial-gradient(circle at 70% 65%,rgba(255,255,255,0.25),rgba(255,255,255,0) 55%);\r\n  mix-blend-mode: overlay;\r\n  pointer-events: none;\r\n}\r\n\r\n.fbp-hero-inner {\r\n  position: relative;\r\n  z-index: 1;\r\n  padding: 38px clamp(24px,6vw,52px);\r\n  max-width: 760px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 22px;\r\n  color: #fff;\r\n}\r\n\r\n.fbp-hero-title {\r\n  font-size: clamp(2.2rem,4.5vw,3.2rem);\r\n  font-weight: 700;\r\n  letter-spacing: -0.5px;\r\n  margin: 0;\r\n}\r\n\r\n.fbp-hero-sub {\r\n  font-size: clamp(1rem,1.45vw,1.25rem);\r\n  line-height: 1.5;\r\n  margin: 0 0 8px 0;\r\n  font-weight: 400;\r\n  max-width: 640px;\r\n}\r\n\r\n/* Primary button reused */\r\n.firstBotPromptAddBtn {\r\n  border: none;\r\n  outline: none;\r\n  background-color: #ffffff;\r\n  font-size: 21px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  padding: 14px 32px;\r\n  border-radius: 16px;\r\n  color: #5616ea;\r\n  display: inline-flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n  box-shadow: 0 4px 12px rgba(94,27,255,0.25);\r\n  cursor: pointer;\r\n  align-self: flex-start;\r\n  transition: background .25s, color .25s, transform .25s, box-shadow .25s;\r\n}\r\n\r\n.firstBotPromptAddBtn:hover {\r\n  background-color: #ebebeb;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.firstBotPromptAddBtn:active {\r\n  transform: translateY(0);\r\n  box-shadow: 0 4px 14px rgba(94,27,255,0.25);\r\n}\r\n\r\n/* Sections */\r\n.fbp-sections { display: flex; flex-direction: column; gap: 56px; }\r\n\r\n.fbp-section-title {\r\n  font-size: 1.6rem;\r\n  margin: 0 0 24px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.fbp-inline-icon { color: #5616ea; }\r\n\r\n/* Features grid — a fixed 3 columns so the six highlights form a tidy 2x3 grid\r\n   the same width as the hero (each box wider). Steps down on smaller screens. */\r\n.fbp-feature-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 22px;\r\n}\r\n\r\n.fbp-feature {\r\n  background: linear-gradient(145deg,#ffffff,#f4f4f8);\r\n  border: 1px solid #e7e7ee;\r\n  border-radius: 18px;\r\n  padding: 18px 18px 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  box-shadow: 0 3px 10px rgba(0,0,0,0.06);\r\n  transition: box-shadow .25s, transform .25s;\r\n}\r\n\r\n.fbp-feature:hover { box-shadow: 0 8px 22px rgba(0,0,0,0.08); transform: translateY(-3px); }\r\n\r\n.fbp-feature-icon {\r\n  width: 46px; height: 46px;\r\n  flex-shrink: 0;\r\n  display: flex; align-items: center; justify-content: center;\r\n  background: #5616ea15;\r\n  color: #5616ea;\r\n  border-radius: 50%;\r\n  font-size: 22px;\r\n}\r\n\r\n.fbp-feature-body h4 { margin: 0 0 6px; font-size: 1.05rem; font-weight: 600; }\r\n.fbp-feature-body p { margin: 0; font-size: .9rem; line-height: 1.4; color: #444; }\r\n\r\n/* Integration logo chips (in the hero top strip) */\r\n.fbp-logo {\r\n  height: 46px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 8px 14px;\r\n  background: #ffffff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.14);\r\n  cursor: pointer;\r\n  transition: transform .2s, box-shadow .2s;\r\n}\r\n\r\n.fbp-logo:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(0,0,0,0.22);\r\n}\r\n\r\n.fbp-logo img {\r\n  max-height: 26px;\r\n  max-width: 100px;\r\n  object-fit: contain;\r\n}\r\n\r\n/* \"Any API\" chip — signals the agent can integrate with any service. */\r\n.fbp-logo-api {\r\n  gap: 7px;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  color: #5616ea;\r\n  white-space: nowrap;\r\n}\r\n\r\n.fbp-logo-api svg { font-size: 15px; }\r\n\r\n/* \"+ more\" chip after the last logo — signals there are more integrations. */\r\n.fbp-logo-more {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  color: #5616ea;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Removed steps & tips sections per request */\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 860px) {\r\n  .fbp-hero-inner { padding: 40px 36px; }\r\n  .fbp-hero-logos { padding: 22px 36px 0; }\r\n  .fbp-hero { min-height: 280px; }\r\n  .fbp-feature-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .firstBotPromptContainer { gap: 32px; }\r\n  .fbp-feature-grid { grid-template-columns: 1fr; }\r\n  .fbp-hero-inner { padding: 34px 28px; }\r\n  .fbp-hero-logos { padding: 20px 28px 0; gap: 8px; }\r\n  .fbp-hero-title { font-size: 2.2rem; }\r\n  .fbp-feature-body p { font-size: .8rem; }\r\n  .fbp-step { padding: 16px 18px; }\r\n  .fbp-step-content p { font-size: .75rem; }\r\n  .fbp-logo { height: 40px; padding: 6px 10px; }\r\n  .fbp-logo img { max-height: 22px; max-width: 84px; }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .firstBotPromptAddBtn,\r\n  .fbp-feature,\r\n  .fbp-logo,\r\n  .fbp-step { transition: none; }\r\n  .fbp-feature:hover,\r\n  .fbp-logo:hover,\r\n  .fbp-step:hover { transform: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
